import Vue from 'vue'
import VueRouter from 'vue-router'
import VeeValidate from 'vee-validate'
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'
import Locale from './languages/locale-en'
import Config from './config/config'
import lodash from 'lodash'
import VueLodash from 'vue-lodash/dist/vue-lodash.min'
import VueMask from 'v-mask'

import './api/api'

Vue.config.devtools = false

/**
 * Configuration for notifications
 */
const toastTypes = {success: 'success', error: 'error', info: 'info', warn: 'warn' }

miniToastr.init({types: toastTypes})

// Here we setup messages output to `mini-toastr`
function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
}

const options = { success: toast, error: toast, info: toast, warn: toast }

VueNotifications.config.position = "toast-bottom-right"

/**
 * Initializing all packages with Vue.js
 */
const dict = require('./languages/en-gb-validation.js');
VeeValidate.Validator.updateDictionary(dict.default);
Vue.use(VueRouter);
Vue.use(VueNotifications, options);
Vue.use(VueLodash, lodash) // Delaying watchers on inputs to prevent spamming the api server
Vue.use(VeeValidate); // Form validation
Vue.use(VueMask);

/*=================================================
    Components
 */

Vue.component('kings-header', require('./components/partials/Header.vue'));
Vue.component('auth-header', require('./components/auth/AuthHeader.vue'));
Vue.component('kings-footer', require('./components/partials/Footer.vue'));
Vue.component('flash-message', require('./components/partials/FlashMessage.vue'));

/*=================================================
    Vue Router
 */

// Each route should map to a component defined above
const routes = [
    /**
     * Package builder
     */
    { name: 'home', path: '/', redirect: { name: 'booking.age' }},
    { name: 'booking.age', path: '/venue/:venueId', component: require('./components/builder/AgeRanges.vue') },
    {
    	name: 'booking.weeks',
    	path: '/venue/:venueId/weeks',
    	component: require('./components/builder/WeeksAvailable.vue')
    },
    {
    	name: 'booking.packages',
    	path: '/venue/:venueId/packages',
    	component: require('./components/builder/BasePackages.vue')
    },
    {
    	name: 'booking.packages.customize',
    	path: '/venue/:venueId/packages/choose',
    	component: require('./components/builder/PackageOptions.vue')
    },

    /**
     * Quick add / Editing bookings
     */
    { name: 'booking.quickadd', path: '/venue/:venueId/child/:childId/quickadd', component: require('./components/cart/QuickAdd/QuickAdd.vue')},

    /**
     * Checkout
     */
    { name: 'cart.basket', path: '/checkout/basket', component: require('./components/cart/Basket/Basket.vue') },
    { name: 'cart.details.confirm', path: '/checkout/basket/account', component: require('./components/cart/Details/AccountDetails.vue') },
    { name: 'cart.participants', path: '/checkout/basket/children', component: require('./components/cart/Participants/Participants.vue') },
    { name: 'cart.participants.complete', path: '/checkout/basket/children/:participantId/complete', component: require('./components/cart/Participants/ParticipantComplete.vue') },
    { name: 'cart.payment', path: '/checkout/payment', component: require('./components/cart/Basket/Basket.vue') },
    { name: 'cart.payment.confirmation', path: '/checkout/payment/confirmation', component: require('./components/cart/Basket/Basket.vue') },

    /**
     * Authentication
     */
    { name: 'auth.register', path: '/signup', component: require('./components/auth/auth.vue') },
    { name: 'auth.login', path: '/signin', component: require('./components/auth/auth.vue') },
    { name: 'auth.password', path: '/forgotten-password', component: require('./components/auth/auth.vue') },
    { name: 'auth.reset', path: '/forgotten-password/reset', component: require('./components/auth/auth.vue') },

    /**
     * My Account
     */
    { name: 'account.overview', path: '/account', component: require('./components/account/Overview.vue')},
    { name: 'account.membership', path: '/account/membership', component: require('./components/account/Membership/Membership.vue')},
    { name: 'account.details', path: '/account/details', component: require('./components/account/AccountDetails/AccountDetails.vue')},
    { name: 'account.payments', path: '/account/payments', component: require('./components/account/Payments/Payments.vue')},
    { name: 'account.children', path: '/account/children', component: require('./components/account/Children/Children.vue')},
    { name: 'account.children.update', path: '/account/children/:id', component: require('./components/cart/Participants/ParticipantComplete.vue')},
    { name: 'account.bookings', path: '/account/bookings', component: require('./components/account/Bookings/Bookings.vue')},
    { name: 'account.bookings.view', path: '/account/bookings/:bookingId', component: require('./components/cart/Basket/Basket.vue')},
    { name: 'account.bookings.item.edit', path: '/account/bookings/:bookingId/edit/:bookingItemId', component: require('./components/cart/QuickAdd/QuickEdit.vue')},
];

/**
 * Creating the router instance
 */
const router = new VueRouter({
    routes
});

/*=================================================
 User Authentication
 */

var auth = undefined;
/**
 * Checking if there is a current session that the user is logged into.
 */
axios.get('/camp-booking/users/current')
    .then(response => {
        /*=================================================
         Application
         */

        const store = {
            builder: {},
            headers: {},
            auth: response.data.data,
            locale: Locale,
            config: Config,
            number_of_items_in_basket: null,
            flash: null
        };


        /*================================================
         Initializing Vue
         */

        /**
         * Initializing the vue application
         */
        new Vue({
            el: '#app',
            data: store,
            computed: {
                booking_id: function () {
                    return this.getCookie('kingscamps_booking_id');
                },
                booking_user_id: function () {
                    return this.getCookie('kingscamps_booking_user_id');
                },
                authenticated: function () {
                    return this.$root.auth && this.$root.auth.user_id != null;
                },
                checkingOut: function () {
                    var routes = ['cart.details.confirm', 'cart.participants', 'cart.participants.complete', 'cart.payment'];
                    return routes.indexOf(this.$route.name) > -1 && this.$root.authenticated;
                },
                venue_id: function () {
                    return this.$route.params.venueId;
                }
            },
            watch: {
                '$route': function (to, from) {
                    if((this.flash && from.name != this.flash.from) || (this.flash && this.flash.hasOwnProperty && this.flash.clear_on_route_change === true))
                        this.flash = null;
                }
            },
            methods: {
                /**
                 * Watching for updates to the current package builder
                 *
                 * @param options
                 */
                updateBuilder: function (options) {
                    switch(options.method) {
                        case 'append':
                        default:
                            this.builder = Object.assign(this.builder, options.data);
                            break;
                    }
                },
                alert: function (message, type = 'danger', timeout = false, scroll = true, clear_on_route_change = false) {
                    timeout = this.config.alert_timeout*1000;
                    var from = this.$route.name;
                    this.flash = {from, type, message, clear_on_route_change};
                    if(timeout) {
                        setTimeout(() => {
                            this.flash = null;
                        }, (Array.isArray(message) ? timeout*message.length : timeout));
                    }
                    if(scroll)
                        setTimeout(() => {
                            $("html, body").animate({scrollTop: $(".title-bar").offset().top}, "slow");
                        }, 500);
                },
                updateBasketCount: function () {
                    if(this.getCookie('kingscamps_booking_id') && this.auth.user_id == null && this.getCookie('kingscamps_booking_id') != 'null' && this.getCookie('kingscamps_booking_user_id') == (this.auth.user_id == null ? 'null' : this.auth.user_id))
                         axios.get('/camp-booking/bookings/'+ this.getCookie('kingscamps_booking_id')+'/items/count')
                             .then(response => {
                                this.number_of_items_in_basket = response.data.data.item_count;
                             })
                    else if(this.auth.user_id != null)
                        axios.get('/camp-booking/users/'+this.auth.user_id+'/basket')
                            .then(response => {
                                this.number_of_items_in_basket = response.data.data.number_of_items_in_basket;
                            })
                    else
                        this.number_of_items_in_basket = 0;
                },
                setCookie: function(cname, cvalue, exdays, seconds = false) {
                    var d = new Date();
                    var date = null;
                    if(seconds)
                        date = new Date(d.getTime() + (Math.abs(exdays) * 1000))
                    else
                        date = d.setTime(d.getTime() + (exdays*24*60*60*1000));
                    var expires = "expires="+ date.toUTCString();

                    var base_domain = this.config.base_domain;
                    var path = base_domain.slice(base_domain.lastIndexOf('/') - base_domain.length).replace(/\/$/, "");
                    document.cookie = cname + "=" + cvalue + ";" + expires + ";path="+path+(window.location.protocol === 'https:' ? ';secure' : '')+';SameSite=None';
                    //document.cookie = cname + "=" + cvalue + ";" + expires + ";path="+path+(window.location.protocol === 'https:' ? ';secure' : '');
                },

                getCookie: function(cname) {
                    var name = cname + "=";
                    var decodedCookie = decodeURIComponent(document.cookie);
                    var ca = decodedCookie.split(';');
                    for(var i = 0; i < ca.length; i++) {
                        var c = ca[i];
                        while (c.charAt(0) == ' ') {
                            c = c.substring(1);
                        }
                        if (c.indexOf(name) == 0) {
                            return c.substring(name.length, c.length);
                        }
                    }
                    return "";
                },
                setBookingId: function (bookingId) {
                    if(bookingId != undefined){
                        this.setCookie('kingscamps_booking_id', (bookingId > 0 ? bookingId : null), this.config.booking_id_expiry, true);
                        this.setCookie('kingscamps_booking_user_id', (bookingId > 0 ? bookingId : null), this.config.booking_id_expiry, true)
                        this.setBookingId();
                    } else if(this.auth.hasOwnProperty('user_id') && this.auth.user_id) {
                        axios.get('/camp-booking/users/' + this.auth.user_id + '/basket')
                            .then(response => {
                                if(response.data.data.booking_id) {
                                    this.setCookie('kingscamps_booking_id', response.data.data.booking_id, this.config.booking_id_expiry, true);
                                    this.setCookie('kingscamps_booking_user_id', this.auth.user_id, this.config.booking_id_expiry, true);
                                } else {
                                    axios.post('/camp-booking/bookings', {
                                        user_id: this.auth.user_id
                                    }).then(response => {
                                        this.setCookie('kingscamps_booking_id', response.data.data.booking_id, this.config.booking_id_expiry, true);
                                        this.setCookie('kingscamps_booking_user_id', this.auth.user_id, this.config.booking_id_expiry, true)
                                    })
                                }
                            })
                    } else {
                        if(this.getCookie('kingscamps_booking_id') > 0 && this.getCookie('kingscamps_booking_user_id') == 'null') {
                            this.setCookie('kingscamps_booking_id', this.getCookie('kingscamps_booking_id'), this.config.booking_id_expiry, true);
                            this.setCookie('kingscamps_booking_user_id', null, this.config.booking_id_expiry, true);
                        } else {
                            axios.post('/camp-booking/bookings', {
                                user_id: null
                            }).then(response => {
                                this.setCookie('kingscamps_booking_id', response.data.data.booking_id, this.config.booking_id_expiry, true);
                                this.setCookie('kingscamps_booking_user_id', null, this.config.booking_id_expiry, true);
                            })
                        }
                    }
                },
            },
            ready () {
                //Initializing Toastr notifications with Vue
                miniToastr.init();
            },
            created () {
                /** Add a response interceptor **/
                axios.interceptors.response.use(function (response) {
                    // Do something with response data
                    return response;
                }, (error) => {
                    // Do something with response error
                    if(error.response != undefined)
                        switch(error.response.status) {
                            case 500:
                                this.alert(this.locale.miscellaneous.something_went_wrong);
                                break;
                            case 401:
                                break;
                            case 403:
                                axios.get('/camp-booking/users/current')
                                    .then(response => {
                                        var user_id = response.data.data.user_id;
                                        if(user_id == null) {
                                            document.cookie = "kingscamps_booking_id=;  Max-Age=0"+(window.location.protocol === 'https:' ? ';secure' : '')+';SameSite=None';
                                            document.cookie = "kingscamps_booking_user_id=;  Max-Age=0"+(window.location.protocol === 'https:' ? ';secure' : '')+';SameSite=None';
                                            this.$root.auth = { user_id: null };
                                            this.$router.push({ name: 'auth.login' });
                                        } else {
                                            if(user_id != this.$root.auth.user_id)
                                                axios.get('/camp-booking/users/'+user_id)
                                                    .then(response => {
                                                        this.$root.auth = Object.assign(response.data.data, { user_id });
                                                    })
                                            this.$router.push({ name: 'account.overview'} );
                                        }
                                        return false;
                                    })
                                break;
                            default:
                                //do nothing
                                break;
                        }
                    else
                        this.alert(this.locale.miscellaneous.something_went_wrong);
                    return Promise.reject(error);
                });

                this.updateBasketCount();
            },
            //Injecting the router instance
            router
        });
    });



// WEBPACK FOOTER //
// ./src/main.js